export default (amount: number) => {
  if (amount >= 1000000) {
    return (amount / 1000000).toFixed(2).replace(/\.00$/, '') + 'M';
  } else if (amount >= 1000) {
    return (amount / 1000).toFixed(0) + 'K';
  } else {
    return amount.toString();
  }
};
